import { useEffect } from "react";

export function useAutoFocus<E extends HTMLElement>(el?: E | null, { enabled = false }: { enabled?: boolean } = {}) {
  useEffect(() => {
    if (enabled) {
      el?.focus();
    }
  }, [el, enabled]);
}
